import axios from 'axios';
import store from '@/state/store'

const instance = axios.create({
  baseURL: 'https://api.mitta.cl:8243/Clientes/1.0.0',
});
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
},
(error) => {
  return Promise.reject(error);
});

instance.interceptors.response.use( (response) => {
  // Si retorna una respuesta sin errores, solamente pasa
  return response;
}, (error) => {
  // Si retorna una respuesta con error distinto al 401 (auth), solamente devuelve el error
  if (error.response.status !== 401) {
    return new Promise((resolve, reject) => {      
      reject(error);
    });
  }

  // Intenta obtener un nuevo token
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.VUE_APP_API_MITTA_TOKEN_PROXY}/default/Mitta-Login`,
      )
      .then((resp) => {
        localStorage.setItem('token', resp.data);
        // Intentar el request con el nuevo token
        const config = error.config;
        config.headers['Authorization'] = config.headers['Authorization'] = `Bearer ${resp.data}`;

        axios.request(config).then(response => {
          resolve(response);
        }).catch((error) => {
          reject(error);
        })
      })
      .catch((error) => {
        reject(error);
      });
  })
});
// Cancelamos las peticiones pendientes
instance.interceptors.request.use(
    config => {
      config.cancelToken = new axios.CancelToken(function (cancel) {
        store.commit('pushToken', {cancelToken: cancel})
      })
      return config;
    })

export default instance;
